
const languages = {
	'it-ch': 'precipitevolissimevolmente',
	'de-ch': 'Silbentrennungsalgorithmus',
	'fr-ch': 'hexakosioihexekontahexaphobie',
	'en-gb': 'antidisestablishmentarianism'
};

let language = document.getElementsByTagName('html')[0].lang.toLocaleLowerCase();

window.Hyphenopoly = {
	require: {
		// Forcing the usage of this script because some needed properties like hyphenate-limit-chars: 10; are not supported
		// in browsers which basically support hyphenation.
		// [language]: languages[language],
		[language]: 'FORCEHYPHENOPOLY'
	},
	fallbacks: {
		'en-gb': 'en-gb',
		'de-ch': 'de',
		'fr-ch': 'fr',
		'it-ch': 'it',
	},

	'cacheFeatureTests': true,

	setup: {
		selectors: {
			".tx-productdb": {
				compound: "hyphen",
				leftmin: 5,
				rightmin: 10
			}
		}
	},

	paths: {
		'patterndir': '/Resources/hyphenopoly/patterns/',
		'maindir': '/Resources/hyphenopoly/'
	}
};
